import { render, staticRenderFns } from "./Recipient.repeat.total.vue?vue&type=template&id=4bd00d4a&"
import script from "./Recipient.repeat.total.vue?vue&type=script&lang=js&"
export * from "./Recipient.repeat.total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports